<template>
  <div>
    <label>Clasificación *</label>
    <treeselect
      data-cy="clasification"
      :value="value"
      placeholder="Seleccione"
      :options="classificationOptions"
      @input="onInput"
    />
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';

import Classifications from '@/febos/chile/dnt/components/wizard/companies/60100003-2/utils/Classifications';

export default {
  data() {
    return {
      classificationOptions: Classifications
    };
  },
  components: {
    Treeselect
  },
  methods: {
    onInput(value) {
      this.$emit('input', value);
    },
  },
  props: {
    value: { type: String }
  }
};
</script>
<style lang="scss">
.vue-treeselect__input-container {
  input {
    padding: 10px;
  }
}
.vue-treeselect__control {
  border-color: #ccc;
}
</style>
